import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { formatDateValueToISOString } from "@/features/FormCard/utils";
import { Option } from "../../types/option";
import { z } from "zod";

// Enum options extracted from Ruby enum in B1MetadataConcern::Enums
export const fieldKeyOptions: Array<Option> = [
  { value: "short_name", label: "Short Name" },
  { value: "short_company_name", label: "Short Company Name" },
  { value: "language", label: "Language" },
];

export const filterB1MetadataSchema = z.object({
  field_key_contains: z.string().nullable().optional(),
  created_at_from: z.any().optional().transform(formatDateValueToISOString),
  created_at_to: z.any().optional().transform(formatDateValueToISOString),
});

export type FilterB1MetadataSchema = z.infer<typeof filterB1MetadataSchema>;

export const fields: Field[] = [
  {
    name: "field_key_contains",
    label: "Field Key",
    type: "select",
    useTranslation: false,
    options: fieldKeyOptions,
  },
  {
    name: "created_at_from",
    label: "Created After",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created Before",
    type: "date",
  },
];

export const client = "b1-quantilia";

export function FilterB1Metadata() {
  return (
    <FilterTable
      client={client}
      schema={filterB1MetadataSchema}
      tableName="b1_metadata"
      customBuildPath={() => `${client}/b1_metadata`}
      fields={fields}
    />
  );
}
